import React from 'react'
import ProductionStagePage from './ProductionStagePage'
import '../styles/_index.scss'

function ProductionStageContainer() {
    return (
        <div className='ProductionStageContainer'>
            <ProductionStagePage/>
        </div>
    )
}

export default ProductionStageContainer